module.exports = __webpack_public_path__ + "static/media/forest.65c0bf9a.svg";